import { TFunction } from "i18next";
import type { HomeSearchSuggestionSelected } from "~/contexts/analytics-context/analytics-events";
import { SearchSuggestionListItem, SearchSuggestionType } from "./types";

export const SEARCH_SUGGESTION_LIST = (
  t: TFunction<readonly ["home"]>,
  searchInputValue: string,
): SearchSuggestionListItem[] => {
  return [
    {
      title: t("home:searchSuggestions.books"),
      items: [
        {
          title: t("home:searchSuggestions.quickSearch"),
          value: searchInputValue,
          hoverText: t("home:searchSuggestions.booksQuickSearchHoverText"),
          type: SearchSuggestionType.BOOKS_QUICK,
        },
        {
          title: t("home:searchSuggestions.semanticSearch"),
          value: searchInputValue,
          hoverText: t("home:searchSuggestions.booksSemanticSearchHoverText"),
          type: SearchSuggestionType.BOOKS_SEMANTIC,
        },
      ],
    },
    {
      title: t("home:searchSuggestions.themaCodes"),
      items: [
        {
          title: t("home:searchSuggestions.quickSearch"),
          value: searchInputValue,
          hoverText: t("home:searchSuggestions.themaCodesQuickSearchHoverText"),
          type: SearchSuggestionType.THEMA_QUICK,
        },
      ],
    },
    {
      title: t("home:searchSuggestions.bisacCodes"),
      items: [
        {
          title: t("home:searchSuggestions.quickSearch"),
          value: searchInputValue,
          hoverText: t("home:searchSuggestions.bisacCodesQuickSearchHoverText"),
          type: SearchSuggestionType.BISAC_QUICK,
        },
      ],
    },
  ];
};

export const SEARCH_SUGGESTION_ANALYTICS: Record<
  SearchSuggestionType,
  Omit<HomeSearchSuggestionSelected["payload"], "query">
> = {
  [SearchSuggestionType.BOOKS_QUICK]: { group: "books", search_type: "quick" },
  [SearchSuggestionType.BOOKS_SEMANTIC]: {
    group: "books",
    search_type: "semantic",
  },
  [SearchSuggestionType.THEMA_QUICK]: {
    group: "thema_codes",
    search_type: "quick",
  },
  [SearchSuggestionType.BISAC_QUICK]: {
    group: "bisac_codes",
    search_type: "quick",
  },
};
